import React, { useState, useEffect } from "react";
import i18next, { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSendVerificationCodeMutation } from "store/auth/register/registerService";
import C from "Constants";
import { ErrorAction, Loader } from "store/actions";
import ButtonSpinner from "components/ButtonSpinner";
import { CustomButton } from "components/Button";
import TextInput from "components/TextInput";
import { SVGICONS } from "config";
import { isEmailValid } from "utils/Validator";
import { UTILS } from "utils";

const LoginForm = ({ gotoVerification }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState({
    value: "",
    error: "",
  });

  const [sendVerificationCode] = useSendVerificationCodeMutation();

  const { brandInfo: brand } = useSelector(
    (state) => state?.brandStorageReducer
  );
  const { loading } = useSelector((state) => state.register);

  const validateEmail = (email) => {
    if (!email) {
      return "Email is required";
    }
    if (!isEmailValid(email)) {
      return "Invalid email address";
    }
    return "";
  }

  const handleSubmit = async (e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    const error = validateEmail(email?.value);
    if (error) {
      setEmail({
        value: email?.value,
        error: error
      });
      return;
    }

    const { data } = await sendVerificationCode({ email: email?.value,
      brandId: brand.brand._id,
      userType: C.CUSTOMER,
      language: i18next.language,
     });
    if (data?.success === 1) {
      gotoVerification({ email: email?.value });
    } else {
      dispatch(ErrorAction.setRegisterError(data?.message || "Something was incorrect."));
      UTILS.errorNotification(data?.message || "Something was incorrect.");
    }
  }

  useEffect(() => {
    dispatch(ErrorAction.setRegisterError(null));
    dispatch(Loader.setLoading(false));
    setEmail({
      value: "",
      error: "",
    });
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <div
        style={{
          margin: "82px 0",
        }}
      >
        <TextInput
          label={t("Enter your Email")}
          value={email?.value || ""}
          onChange={(e) =>
            setEmail({
              value: e?.target?.value,
              error: validateEmail(e?.target?.value)
            })
          }
          name="email"
          mandatory={true}
          labelClasses="text-14x text-black"
          placeholder={t("example@email.com")}
          readOnly={false}
          error={t(email?.error)}
          icon={<SVGICONS.EmailIcon />}
        />
      </div>
      <CustomButton
        type="submit"
        disabled={loading}
      >
        {loading ? (
            <ButtonSpinner
              height="30px"
              width="30px"
              color="text-white mx-1 inline-block"
            />
          ) : (
            t("Send Code")
          )}
      </CustomButton>
    </form>
  );
};

export default LoginForm;
